import { Card, Dialog, Divider, Grid, Typography } from '@mui/material'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { ModalAddressForm } from '../accounts'

type Props = {
  address: IAddressCustomer
  selectAddress: IAddressCustomer
  listCities?: City[]
  handleSelectAddtress: (e: any, data: IAddressCustomer) => void
}

export const ItemAddressCheckout = ({ address, selectAddress, listCities, handleSelectAddtress }: Props) => {
  const t = useTranslations()
  const district = address?.custom_attributes?.find((item) => item.attribute_code === 'district')?.value
  const ward = address?.custom_attributes?.find((item) => item.attribute_code === 'ward')?.value
  const isSelect = selectAddress?.id === address?.id
  const [isEdit, setIsEdit] = useState(true)
  return (
    <>
      <Grid
        size={{
          xs: 24,
          md: 12,
        }}
        onClick={() => {
          handleSelectAddtress(null, address)
        }}
      >
        <Card className={`cursor-pointer border border-solid ${isSelect ? '!border-sub-color' : ''}`}>
          <CardHeader
            action={
              <div className="flex items-center gap-2">
                <span onClick={() => setIsEdit(false)} className="underline">
                  {t('Change')}{' '}
                </span>
              </div>
            }
            title={
              <div>
                <span className="mr-1 text-base font-semibold">
                  {address?.firstname + ' ' + address?.lastname}{' '}
                </span>
                {!!address?.default_shipping && (
                  <span className=" rounded-full bg-lime-600 px-2 py-1 text-xs">
                    {address?.default_shipping ? t('Default') : ''}{' '}
                  </span>
                )}
              </div>
            }
          />
          <Divider />
          <CardContent>
            <div>
              <span className="font-semibold">Số điện thoại:</span> <span>{address?.telephone}</span>
            </div>
            <div className="min-h-12">
              <span className="font-semibold">Địa chỉ:</span>{' '}
              <span>
                {address?.street[0]} {!!ward && ', ' + ward} {!!district && ', ' + district}{' '}
                {address?.city && ', ' + address?.city}
              </span>
            </div>
          </CardContent>
        </Card>
      </Grid>

      <Dialog open={!isEdit} onClose={() => setIsEdit(true)}>
        <Typography component={'h2'} variant="h4">
          {t('Edit Address')}
        </Typography>
        <ModalAddressForm
          key={'update'}
          type={'update'}
          onCancel={() => setIsEdit(false)}
          isModal={true}
          defaultValue={address ?? undefined}
        />
      </Dialog>
    </>
  )
}
